export default __webpack_public_path__ + "static/media/logo-placeholder.a8ec1b88.png";